import { render, staticRenderFns } from "./AppNotice.vue?vue&type=template&id=73e47d39&"
import script from "./AppNotice.vue?vue&type=script&lang=js&"
export * from "./AppNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports